import { InsuranceActivationStatus } from '@/@types/insurance';
import { APP_CONFIG } from '@/config';
import { GeneralApiError } from '@/domain/errors/GeneralApiError';
import { ApiEndpoints } from '../apiEndpoints.constant';
import { get, post } from '../request';

export interface AdacApplicationForm {
  firstName: string;
  lastName: string;
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  birthDate: string;
  countryCode: 'DEU';
}

export interface AdacApplicationStatus {
  insuranceStatus: InsuranceActivationStatus;
  customerNumber: string;
  applicationId?: string | null;
  customerData?: AdacApplicationForm | null;
}

export const getAdacApplication = () =>
  get<AdacApplicationStatus>(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.adacApplication}`, 'XSRF-TOKEN');

export const submitAdacApplication = async (form: AdacApplicationForm): Promise<AdacApplicationStatus> => {
  // Check before every attempt: a previous request may have been saved despite a lost response.
  const current = await getAdacApplication();
  if (current.insuranceStatus !== InsuranceActivationStatus.NOT_ACTIVATED) return current;
  if (current.applicationId) throw new GeneralApiError(409);

  try {
    const result = await post<AdacApplicationStatus, AdacApplicationForm>(
      `${APP_CONFIG.baseApiUrl}${ApiEndpoints.adacApplication}`,
      form,
      'XSRF-TOKEN',
    );
    if (!result) throw new GeneralApiError();
    return result;
  } catch (error) {
    if (error instanceof GeneralApiError && error.responseStatus === 409) {
      const saved = await getAdacApplication();
      if (saved.insuranceStatus !== InsuranceActivationStatus.NOT_ACTIVATED) return saved;
    }
    throw error;
  }
};
